/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Modal, { ModalHeader } from "../Modal";
import Form from "../Form";
import useForm from "../../hooks/useForm";
import { getMonthRange } from "../../utils/date";
import { isEmpty } from "../../utils/lodashExtend";
import { addAdContents, editAdContents } from "../../apis/admin/adManagers";
import { toast } from "../../utils/toast";
import { isNumber } from "../../utils/validator";
import { VIEW_TYPES } from "../../constants/AD_CONTENT";



const defaultForm = {
  startTime: `${getMonthRange(0).from} 00:00`,
  endTime: `${getMonthRange(0, true).to} 23:59`,
  isActive: "true",
  actions: {
    type: "webLink",
  },
  viewType: VIEW_TYPES[0].value
};


const AdContentDetail = ({ open, setOpen, selectedItem, setSelectedItem, submit }) => {
  const [mode, setMode] = useState("create");
  const [fields, setFields] = useState([]);

  const _submit = (_form) => {
    const form = {
      ..._form,
      isActive: _form.isActive === "true",
      endTime: _form.endTime[0],
      startTime: _form.startTime[0],
      imageIdx: isNumber(_form.imageFile[0]) ? _form.imageFile[0] : _form.imageFile[0].idx,
      order: +_form.order,
    };
    delete form.imageFile;

    if (mode === "create") {
      addAdContents(form)
        .then(res => {
          toast.success("광고 배너 컨텐츠가 등록되었습니다.");
          submit && submit();
          close();
        });
    } else {
      editAdContents(selectedItem.idx, form)
        .then(res => {
          toast.success("광고 배너 컨텐츠가 수정되었습니다.");
          submit && submit();
          close();
        });
    }
  };

  const {
    form,
    errors,
    setForm,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields,
    resetForm,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    !isEmpty(fields) && setValidateFields(fields);
  }, [fields]);

  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    setSelectedItem(null);
    setOpen(false);
    resetForm(defaultForm);
  };

  useEffect(() => {
    if (open) {
      setMode(selectedItem ? "modify" : "create");
      if (selectedItem) {
        setForm({
          ...selectedItem,
          isActive: selectedItem.isActive ? "true" : "false",
          order: `${selectedItem.order}`
        });
        setOriginForm({
          ...selectedItem,
          isActive: selectedItem.isActive ? "true" : "false",
          order: `${selectedItem.order}`
        });
      } else {
        setForm(defaultForm);
        setOriginForm(defaultForm);
      }
    }

  }, [open, selectedItem]);

  useEffect(() => {

    setFields([
      [
        {
          title: "컨텐츠명",
          key: "title",
          type: "input",
          required: true,
        }
      ],
      [
        {
          title: "광고 링크 종류",
          type: "select",
          key: "actions.type",
          options: {
            list: [
              { label: "웹 링크", value: "webLink" },
              { label: "앱 링크", value: "appLink" },

            ]
          },
          required: true,
        },
        {
          title: "웹 링크 URL",
          type: "input",
          key: "actions.url",
          required: true,
        }
      ],
      [
        {
          title: "IOS 링크 URL",
          type: "input",
          key: "actions.iosUrl",
          required: form?.actions.type === "appLink",
          tooltip: "광고링크 - 앱링크의 경우 앱스토어 바로가기를 위해 필요한 링크입니다.",
          isHide: (f => form?.actions.type === "webLink")
        },
        {
          title: "android 링크 URL",
          type: "input",
          key: "actions.androidUrl",
          required: form?.actions.type === "appLink",
          tooltip: "광고링크 - 앱링크의 경우 앱스토어 바로가기를 위해 필요한 링크입니다.",
          isHide: (f => form?.actions.type === "webLink")
        }
      ],
      [
        {
          title: "광고 시작일",
          type: "datetimepicker",
          key: "startTime",
          required: true,
        },
        {
          title: "광고 종료일",
          type: "datetimepicker",
          key: "endTime",
          required: true,
        },
      ],
      [
        {
          title: "배너 이미지",
          type: "dropzone",
          key: "imageFile",
          required: false,
          isAdmin: true,
          changeDefaultFile: true,
        },
      ],
      [
        {
          title: "활성여부",
          key: "isActive",
          type: "radio",
          options: {
            list: [{ label: "활성", value: "true" }, { label: "비활성", value: "false" }]
          },
        },
        {
          title: "노출 순번",
          key: "order",
          type: "number",
          required: true,
        },
      ],
      [
        {
          title: "노출타입",
          key: "viewType",
          type: "select",
          options: {
            list: VIEW_TYPES
          },
        },
        {
          isHide: ({ form }) => {
            return form.isSecret !== '999999';
          },
        },
      ],
      [
        {
          title: "비고",
          key: "description",
          type: "textarea",
        }
      ],
    ]);
  }, [form]);
  return (
    <>
      <Modal
        isOpen={open}
        close={close}
      >

        <ModalHeader>
          {`광고 배너 컨텐츠 ${mode === "create" ? "등록" : "수정"}`}
        </ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === "create" ? "등록" : "수정"}
          submit={handleSubmit}
          cancel={close}
        />
      </Modal>
    </>
  );
};

export default AdContentDetail;